import LftArrowLeftIcon from '@lift/assets/dist/assets/globals/icons/arrow_left';
import LftIconBase from '@lift/design-system-react-web/dist/components/LftIconBase';
import LftTypography from '@lift/design-system-react-web/dist/components/LftTypography';
import React from 'react';
import S from './botao-voltar.styles';
import { BotaoVoltarProps } from './botao-voltar.types';

export const BotaoVoltar: React.FC<BotaoVoltarProps> = ({
  onClick,
  ariaLabel,
  semMargem,
  dataElement,
}) => {
  return (
    <S.Button
      noMargin={semMargem}
      onClick={onClick}
      aria-label={ariaLabel}
      data-element={dataElement}
      data-testid="btn-voltar"
    >
      <LftIconBase icon={LftArrowLeftIcon} size="md" />
      <LftTypography component="paragraph">Voltar</LftTypography>
    </S.Button>
  );
};
